<template>
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-4 lg:-mx-2 table-content">
      <div class="py-1 align-middle min-w-full inline-block sm:px-2 lg:px-2">
        <div
            class="sm:rounded-lg">
          <table class="min-w-full divide-y divide-gray-200 shadow border-b border-gray-200 ">
            <thead class="bg-gray-50 sticky top-0 shadow-sm z-10">
            <tr>
              <th scope="col" class="px-6 py-3 text-xs font-medium text-gray-500 uppercase tracking-wider"
                  v-for="(row, index) in aux_fields" :key="index" :class="row.thclass?row.thclass:''">
                {{ row.label ? limpiarTexto(row.label) : limpiarTexto(row) }}
              </th>
            </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
            <tr v-if="items.length===0">
              <td class="px-6 py-2 whitespace-nowrap text-gray-700" :colspan="aux_fields.length">
                <slot name="table-empty">
                  <p class="text-center text-gray-500 text-lg">{{ tableEmptyMessage }}</p>
                </slot>
              </td>
            </tr>
            <tr v-for="(item, index) in items" :key="index">
              {{ agregarIndex(item, index) }}
              <td class="py-2 text-gray-700" v-for="(row, key) in aux_fields" :key="key"
                  :class="row.class ? row.class: ''">

                <span v-if="!row.key && row==='n'">
                  {{ ++index }}
                </span>
                <slot :name="row.key?row.key:row" v-bind:item="item">
                  {{ row.key ? item[row.key] : item[row] }}
                </slot>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tablecomponent",
  props: {
    fields: {
      type: Array,
      default: Array
    },
    items: {
      type: Array,
      default: []
    },
    showIndex: false,
    tableEmptyMessage: {
      type: String,
      default: 'No Hay Datos'
    }
  },
  data: () => ({
    aux_fields: [],
  }),
  methods: {
    limpiarTexto(text) {
      return text.replaceAll('_', ' ')
    },
    agregarIndex(item, index) {
      item.index = index
    }
  },
  mounted() {
    if (Array.isArray(this.fields) && this.fields.length > 0) {
      this.aux_fields = this.fields
    } else {
      if(this.fields.length<=0)
        this.aux_fields = Object.keys(this.items[0])
    }

    if (this.showIndex)
      this.aux_fields.unshift('n')
  },
  watch:{
    items(){
      if(this.fields.length<=0)
        this.aux_fields = Object.keys(this.items[0])
    }
  }
}
</script>

<style lang="scss">
.table-content::-webkit-scrollbar{
  height: .5rem;
}

.table-content::-webkit-scrollbar-track{
  @apply bg-gray-100;
}

.table-content::-webkit-scrollbar-thumb{
  @apply bg-gray-300;
  border-radius: .25rem;
&:active{
   @apply bg-gray-500;
 }
}

</style>